import { createSelector } from "reselect";
import { RootState } from "../../types";

const getFeedComments = ({ feedDetails }: RootState) => feedDetails;

export const feedDetailsSelector = createSelector([getFeedComments], (feedDetails) => feedDetails);
